import { SxProps, Theme } from '@mui/material';

import { OverflowAwareText } from '~components/Order/ordersDispatchStyledComponents';
import { Project } from '~hooks/useProjects/models';

interface TitleProps {
  project: Project;
  sx?: SxProps<Theme>;
}

export default function Title({ project, sx }: TitleProps) {
  return (
    <OverflowAwareText
      sx={[{ fontSize: '16px', fontWeight: 600 }, ...(Array.isArray(sx) ? sx : [sx])]}
    >
      {project.name}
    </OverflowAwareText>
  );
}
